exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__grid___cc6NN{display:grid}@media (min-width:768px){.index-module__grid___cc6NN{grid-template-columns:1fr}}.index-module__grid___cc6NN .index-module__item___WYA1l .index-module__range___2eR3D{color:#707070;font-size:18px;font-weight:500;padding:0 1rem;margin-bottom:-.4rem;display:flex;text-transform:uppercase}.index-module__grid___cc6NN .index-module__item___WYA1l{width:100%;display:flex;flex-direction:column;gap:1.2rem}", ""]);

// exports
exports.locals = {
	"grid": "index-module__grid___cc6NN",
	"item": "index-module__item___WYA1l",
	"range": "index-module__range___2eR3D"
};